module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Light-951c5254c8c4aff4fd790906be216bb8.woff";